import React from 'react'
import { DrawerModal, ModalVisibilityProps } from 'sb-modal'

import { Box } from 'components/_new/layout'
import { Button } from 'components/_new/controls'

import SelectableRating from 'components/_new/controls/SelectableRating/SelectableRating'
import ProductInfo from 'compositions/modals/review/ReviewModalView/components/ProductInfo/ProductInfo'

import messages from './messages'


type ReviewLatestScentModalViewProps = Pick<ModalVisibilityProps, 'onClose'> & {
  product: Review.Product
  onRate: (rating: Review.Rating) => void
  onRemindLater: () => void
}


export const ReviewLatestScentModalView: React.FunctionComponent<ReviewLatestScentModalViewProps> = (props) => {
  const { product, onRate, onRemindLater, onClose } = props

  return (
    <DrawerModal
      title={messages.title}
      text={messages.text}
      onClose={onClose}
    >
      <Box mt={16}>
        <ProductInfo product={product}>
          <Box mt={16}>
            <SelectableRating
              size={24}
              value={0}
              onChange={onRate}
            />
          </Box>
        </ProductInfo>
        <Box mt={32}>
          <Button
            color="transparent"
            size="md"
            fullWidth
            title={messages.remindLater}
            onClick={onRemindLater}
          />
        </Box>
      </Box>
    </DrawerModal>
  )
}


export default ReviewLatestScentModalView
